import DashboardLayout from '../Layouts/DashboardLayout';
import CareerPathwayComp from './CareerPathwayComp';
const CareerPathwayContainer = () => {
  return (
    <DashboardLayout>
        <CareerPathwayComp></CareerPathwayComp>
    </DashboardLayout>
  );
};
export default CareerPathwayContainer;